import { styled } from "@mui/material";

export const Wrapper = styled("div")((props) => ({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: props.fullScreen ? "100svh" : "100%",
  justifyContent: "center",
  width: "100%",
}));

export const Styles = {
  Wrapper,
};
